<template>
    <div class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
</template>

<script>
    export default {
        name: "main-loader"
    }
</script>

<style scoped>
    /* TODO: Move styles */
</style>
